import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

/**
 * The JSM Personalized Journey Type Route.
 * Personalized Journey Type: /jira/servicedesk/projects/:projectKey/journeys/pending/:journeyTypeId
 */
export const personalizedJourneyTypeRoute: InvariantJiraRoute = {
	path: '/jira/servicedesk/projects/:projectKey/journeys/pending/:journeyTypeId',
	name: 'journey-type',
	exact: true,
};
